import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { DraftingApi, DraftingApiImpl } from './apis';

export const draftingContainer = new ContainerModule((bind) => {
    bind(DraftingApi).to(DraftingApiImpl);
});
